module.exports = {
        srcSet: __webpack_public_path__ + "static/media/mailOpenedMobile-500.37370788.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/mailOpenedMobile-500.37370788.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/mailOpenedMobile-500.37370788.webp",
        toString: function(){return __webpack_public_path__ + "static/media/mailOpenedMobile-500.37370788.webp"},
        
        width: 500,
        height: 500
      }